module.exports = __webpack_public_path__ + "static/campbaylodge-cad80efafb58c2a12e19fac37e359e2e.jpg";